import React from 'react';
import './Footer.css';
import SocialIcons from './SocialIcons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} Technical One. All Rights Reserved.</p>
        <SocialIcons />
      </div>
    </footer>
  );
};

export default Footer;
